export default __webpack_public_path__ + "static/media/April2022.326d0741.png";